import React from "react";
import { useListContext } from "react-admin";
import { RaGrid } from "ra-compact-ui";
import ShowTitle from "../../../components/ShowTitle";
import {
  DatagridTextField,
  DatagridReferenceTextField,
} from "../../../components";

const MainBusinessRelationshipsIterator = () => {
  const { ids, data, basePath } = useListContext();

  return (
    <>
      <RaGrid item xs={12}>
        <ShowTitle title="Información de la subsidiaria o relacionada" />
      </RaGrid>
      {ids.map((id, index) => (
        <RaGrid key={index} container item xs={12}>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="businessRelationshipTypeId"
              reference="business-relationship-types"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="businessName"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="managerName"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="documentTypeId"
              reference="document-types"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="documentNumber"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="managerPhoneNumber"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={12}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="address"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="countryId"
              reference="countries"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="provinceId"
              reference="provinces"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="cityId"
              reference="cities"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
        </RaGrid>
      ))}
    </>
  );
};

MainBusinessRelationshipsIterator.defaultProps = {
  addLabel: true,
  data: {},
  ids: [],
};

export default MainBusinessRelationshipsIterator;
